
import React from "react";
import { Users, UserPlus, Heart } from "lucide-react";

const UserProfilesHeader = () => {
  return (
    <div className="mb-6">
      <div className="flex items-center gap-3 mb-3">
        <div className="p-2 bg-gradient-to-r from-blue-500/10 to-purple-500/10 rounded-lg">
          <Users className="h-5 w-5 text-blue-600" />
        </div>
        <h3 className="text-xl font-bold text-foreground">Discover Amazing People</h3>
      </div>
      <div className="space-y-2">
        <p className="text-sm text-muted-foreground leading-relaxed">
          Connect with fellow teens, share your journey, and build meaningful friendships! 
        </p>
        <div className="flex items-center gap-4 text-xs text-muted-foreground">
          <div className="flex items-center gap-1">
            <UserPlus className="h-3 w-3 text-green-500" />
            <span>Follow to connect</span>
          </div>
          <div className="flex items-center gap-1">
            <Heart className="h-3 w-3 text-red-500" />
            <span>Build your network</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfilesHeader;
